import { Controller } from 'react-hook-form'

import {
  DayOfMonth,
  DayOfMonthSelector,
} from '@/modules/tasks/components/task-scheduler-dialog/day-of-month-selector.tsx'

export const MonthlyRepetitionSelector = () => {
  return (
    <Controller
      name="rateDayOfMonth"
      render={({ field }) => (
        <>
          <DayOfMonthSelector
            value={field.value}
            onChange={field.onChange}
          />
          <span className="block text-secondary-300 text-xs">
            {field.value ? (
              <>
                The Task will be scheduled on every{' '}
                <strong className="font-medium">
                  <DayOfMonth day={field.value} />
                </strong>{' '}
                day of the month
              </>
            ) : (
              'No day is selected'
            )}
          </span>
        </>
      )}
    />
  )
}
